import React, { useState, useRef, Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import TetherComponent from 'react-tether'
import FaIcon from '../fa_icon'

const DropdownMenu = (props) => {
  const handleItemClick = (e, callback) => {
    if (callback) {
      e.preventDefault()
      callback()
    }
    if (props.onClickItem) {
      props.onClickItem()
    }
  }

  return (
    <ul className={ `dropdown-menu glg-react-dropdown-menu sim_golf_dashboard` }>
      {props.items.map((item, index) => (
        <Fragment key={ index }>
          <li key={ index }>
            <a
              href={ item.url || '#' }
              id={ item.url ? 'link_option' : 'normal_option' }
              onClick={ e => handleItemClick(e, item.onClick) }
              className={ item.label == 'Delete' ? 'red' : '' && item.disabled ? 'disabled' : '' }
            >
              { !item.url && (
                <img src={ item.image } />
              )}
              { item.label }
              { item.url && (
                <FaIcon icon='angle-right' />
              )}
            </a>
          </li>
          { item.destination &&
            <hr />
          }
          { item.label == 'Archive' &&
            <hr />
          }
        </Fragment>
      ))}
    </ul>
  )
}

DropdownMenu.propTypes = {
  items: PropTypes.array.isRequired,
  onClickItem: PropTypes.func,
}

const SimDropdown = (props) => {
  const inputRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutsideOfMenu)

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideOfMenu)
    }
  }, [])

  const handleButtonClick = () => {
    setIsOpen(!isOpen)
  }

  const handleClickOutsideOfMenu = (e) => {
    if (e.target.parentElement !== inputRef) {
      setIsOpen(false )
    }
  }

  const otherDirection = props.direction === 'left' ? 'right' : 'left'
  const attachment = `top ${otherDirection}`
  const targetAttachment = `bottom ${props.direction}`

  return (
    <div className='glg-react-dropdown'>
      <TetherComponent
        attachment={ attachment }
        targetAttachment={ targetAttachment }
        offset='4px 0'
        constraints={ [ { to: 'window', pin: true } ] }
      >
        <div className='dropdown content-dropdown'>
          <a className='dropdown-button dropdown-toggle dropdown_button_icon clickable'
              onClick={ handleButtonClick }
              ref={ buttonRef => { inputRef.current = buttonRef } }
          >
            <FaIcon icon='ellipsis' />
          </a>
        </div>
        {isOpen && (
          <DropdownMenu
            items={ props.items }
            onClickItem={ handleButtonClick }
          />
        )}
      </TetherComponent>
    </div>
  )
}

SimDropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    id: PropTypes.string,
  })).isRequired,
  direction: PropTypes.string,
}

SimDropdown.defaultProps = {
  direction: 'right',
}

export default SimDropdown